import { render, staticRenderFns } from "./LINKMAGA.vue?vue&type=template&id=76c1a4e5&scoped=true&"
import script from "./LINKMAGA.vue?vue&type=script&lang=js&"
export * from "./LINKMAGA.vue?vue&type=script&lang=js&"
import style0 from "./LINKMAGA.vue?vue&type=style&index=0&id=76c1a4e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c1a4e5",
  null
  
)

export default component.exports